<template>
  <div class="mainBox wow animate__animated animate__fadeIn">
    <Loading :visible="loading"></Loading>
    <div class="title" style="text-align: center;margin:2rem 0;">
      <div class="text1">公司新闻</div>
    </div>
    <!-- <el-input
      v-model="newsTitle"
      placeholder="请输入新闻标题"
      autofocus
      :prefix-icon="Search"
      clearable
      size="large"
      width="20vw"
      style="margin-bottom: 2rem; width: 40vw"
      @keyup.enter="getList"
      @clear="getList"
    /> -->
    <div class="mewsList">
      <div class="mewsItem maria" v-for="(item, index) in list" :key="index"
        @click="navTo('/news/detail', { id: item.id })">
        <OssImg class="newsImg" fit="cover" :src="item.newsOssUrl"></OssImg>
        <div class="mewsItemInfo">
          <div class="ellipsis-multiline" style="-webkit-line-clamp: 2">
            {{ item.newsTitle }}
          </div>
          <div>{{ item.createTime.split(' ')[0] }}</div>
        </div>
      </div>
    </div>
    <div class="display_flex" style="margin: 2rem 0">
      <Pagenation v-bind="pageInfo" @changePage="changePage"></Pagenation>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import Pagenation from "@/components/Pagenation.vue";
import NewsApi from "@/api/newsApi";
import { navTo } from "@/utils/util";
import { Search } from "@element-plus/icons-vue";
import OssImg from "@/components/ossImg.vue";
const newsApi = new NewsApi();
const newsTitle = ref("");
const list = ref([]);
const loading = ref(true);

onMounted(() => {
  getList();
});
const pageInfo = ref({
  total: 0,
  pageSize: 12,
  pageNum: 1,
});


const changePage = (page) => {
  pageInfo.value.pageNum = page;
  getList();
};

//获取列表
const getList = async () => {
  try {
    let res = await newsApi.getNewsList({
      newsTitle: newsTitle.value,
      pageSize: pageInfo.value.pageSize,
      pageNum: pageInfo.value.pageNum,
    });
    list.value = res.rows || [];
    pageInfo.value.total = res.total
    loading.value = false;
  } catch (error) {
    loading.value = false;
  }
};
</script>

<style lang="scss" scoped>
.mewsList {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  min-height: 500px;

  .mewsItem {
    height: 22.25rem;
    border-radius: 1rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;

    .newsImg {
      width: 100%;
      height: 13.75rem;
      object-fit: cover;
      border-radius: 1rem 1rem 0 0;
    }

    .mewsItemInfo {
      width: 100%;
      flex: 1;
      padding: 1rem;
      box-sizing: border-box;
      text-align: justify;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      >div:first-of-type {
        font-size: 1.3rem;
        line-height: 2.125rem;
        font-weight: 600;
        color: #424242;
      }

      >div:nth-child(2) {
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-weight: 500;
        color: #888888;
      }
    }
  }
}

// @media(max-width: 768px) {
//   .mewsList {
//     grid-template-columns: repeat(2, 1fr);
//     padding: 0 1rem;
//     box-sizing: border-box;
//   }
// }</style>
